import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { DeviceInfoViewComponent } from './device-info-view.component';
import { DeviceInfographicsComponent } from './device-infographics/device-infographics.component';
import { TooltipModule } from '@soti/tooltip';

@NgModule({
    declarations: [DeviceInfoViewComponent, DeviceInfographicsComponent],
    providers: [XsI18nPipe],
    imports: [CommonModule, SharedComponentsModule, MatTooltipModule, PipesModule, TooltipModule],
    exports: [DeviceInfoViewComponent]
})
export class DeviceInfoViewModule {}
